
const compareAccounts = function ( left, right ) {
    if ( left.location < right.location )
        return -1;

    if ( left.location > right.location )
        return 1;

    if ( left.description < right.description )
        return -1;

    if ( left.description === right.description )
        return 0;

    return 1;
};

export {  compareAccounts };
